module.exports = __webpack_public_path__ + "static/media/menu.c8853bc3.svg";